import React from "react";
import UsedCarsWorkspace from "../components/UsedCarsWorkspace";

export default function UsedCarsStockPage() {
  return <UsedCarsWorkspace stage="stock" />;
}
